import { render, staticRenderFns } from "./boardInfo.vue?vue&type=template&id=288cdd9c"
import script from "./boardInfo.vue?vue&type=script&lang=js"
export * from "./boardInfo.vue?vue&type=script&lang=js"
import style0 from "./boardInfo.vue?vue&type=style&index=0&id=288cdd9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports